import React from 'react'
import DefaultContainer from '../../components/container/DefaultContainer'
import Header from '../../components/container/Header'
import MainNaviagation from '../../components/navigation/MainNaviagation'
import HeaderTitle from '../../components/inner/HeaderTitle'
import Title from '../../components/header/HeaderTitle'
import Footer from '../../components/container/Footer'

import AboutContainer from '../../components/container/company/AboutContainer'
import HeaderContainer from '../../components/header/HeaderContainer'
import HeaderContent from '../../components/header/HeaderContent'
import COLOR from '../../global/Color'
import styled from 'styled-components'

import BackgroundImage from '../../assets/contactBackgroundImage.png'
import Adress from '../../assets/main/ContactAdressIcon.png'
import Phone from '../../assets/main/ContactPhoneIcon.png'
import Fax from '../../assets/main/ContactFaxIcon.png'
import ContactInnerItem from '../../components/inner/contact/ContactInnerItem'
import { useLanguage } from '../../context/LanguageContext';
import { siteCopy } from '../../i18n/landingCopy';

const Contact = () => {

  const { language } = useLanguage();
  const copy = siteCopy[language]?.pages?.contact || siteCopy.en.pages.contact;

  const EmailSend = ({ email, subject, children }) => {
    return (
      <a href={`mailto:${email}?subject=${encodeURIComponent(subject)})`} style={{textDecoration: 'none'}}>
        {children}
      </a>
    )
  }

  return (
    <DefaultContainer>
      <Header headerBackgroundImage={BackgroundImage}>
        <MainNaviagation />
        <HeaderTitle>{copy.title}</HeaderTitle>
      </Header>

      <>
        <HeaderContainer>
          <Title>{copy.title}</Title>
          <HeaderContent>{copy.intro}{' '}
            <EmailSend email={'support@eplus.co.kr'} subject={'문의드립니다.'}>
              <span style={{color: COLOR.MAGORELLEBLUE, fontWeight: 700, textDecoration: 'underline'}}>Eplus</span>
            </EmailSend>
            {copy.contactTo}</HeaderContent>
          
          <MapContainer>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5626.839313972437!2d127.09566859216243!3d37.40606866606508!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca78a348106a5%3A0x2af237b33940ee6e!2zKOyjvCnsnbTtlITrn6zsiqQ!5e0!3m2!1sko!2skr!4v1718682401408!5m2!1sko!2skr" loading="lazy" style={{width: '100%', height: '100%'}} />
          </MapContainer>
          
          <InfoContainer>
            <ContactInnerItem Icon={Adress} title={copy.items[0].title}>{copy.items[0].value}</ContactInnerItem>
            <ContactInnerItem Icon={Phone} title={copy.items[1].title}>{copy.items[1].value}</ContactInnerItem>
            <ContactInnerItem Icon={Fax} title={copy.items[2].title}>{copy.items[2].value}</ContactInnerItem>
          </InfoContainer>
        </HeaderContainer>
      </>

      <Footer />
    </DefaultContainer >
  )
}

const MapContainer = styled.div`
  width: 73vw;
  height: 60vh;
  
  /* 800px 이상 1300px 미만 */
  @media (min-width: 800px) and (max-width: 1299px) {
    height: 50vh;
  }
  
  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    height: 40vh;
  }
  
  /* 450px 미만 */
  @media (max-width: 449px) {
    height: 30vh;
  }
`

const InfoContainer = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 1px solid #ccc;

  /* 800px 이상 1300px 미만 */
  @media (min-width: 800px) and (max-width: 1299px) {
    flex-direction: column;
  }
  
  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    padding-top: 5%;
    flex-direction: column;
  }
  
  /* 450px 미만 */
  @media (max-width: 449px) {
    padding-top: 5%;
    flex-direction: column;
    font-size: small;
  }
`

export default Contact
